import { createSelector, createSlice } from "@reduxjs/toolkit"
import { getSessionLoggedOut, getUserDataConfig } from "@/utils/helpers/configs"
import { RootState } from "@/store"

const matrixData = getUserDataConfig()

const initialState = {
  matrixData: matrixData && { ...matrixData },
  memberId: matrixData?.metadata?.memberId?.value ?? null,
  loggedOut: getSessionLoggedOut(),
}

export const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setMemberId: (state, action) => {
      state.memberId = action.payload
    },
    setLoggedOut: (state, { payload }) => {
      state.loggedOut = payload
    },
    clearMatrixData: (state) => {
      state.matrixData = null
      state.memberId = null
    },
  },
})

// actions
export const { setMemberId, setLoggedOut, clearMatrixData } =
  memberSlice.actions

// Selectors
export const selectMember = (state: RootState) => state.member
export const selectMemberMatrixData = createSelector(
  selectMember,
  (member) => member?.matrixData
)
export const selectMemberId = createSelector(
  selectMember,
  (member) => member?.memberId
)

export const selectIsAdmin = createSelector(
  selectMemberMatrixData,
  (member) => member?.isAdmin ?? false
)

export const selectHasMemberId = createSelector(
  selectMemberMatrixData,
  (member) => member?.metadata?.memberId ?? false
)

export const selectLoggedOut = (state: RootState) => state.member.loggedOut

// Reducer
export default memberSlice.reducer
